import { render, staticRenderFns } from "./SummaryVisaCountryPage.vue?vue&type=template&id=39c9407c&scoped=true&"
import script from "./SummaryVisaCountryPage.vue?vue&type=script&lang=js&"
export * from "./SummaryVisaCountryPage.vue?vue&type=script&lang=js&"
import style0 from "./SummaryVisaCountryPage.vue?vue&type=style&index=0&id=39c9407c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c9407c",
  null
  
)

export default component.exports